import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";

import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import SpecialsPage from "@/pages/SpecialsPage";
import QuotePage from "@/pages/QuotePage";
import JoinTeamPage from "@/pages/JoinTeamPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/specials" element={<SpecialsPage />} />
          <Route path="/quote/:slug" element={<QuotePage />} />
          <Route path="/join" element={<JoinTeamPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
